import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.Save.IRequest;
type Response = Api.Core.StatementBalance.Save.IResponse;
type Headers = Api.Core.StatementBalance.Save.IHeaders;
const url = '/api/DealerManagement/StatementBalance';
export default async function statementBalanceSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
